/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import {LservVue} from '@/shell/LservVue';

/**
 * An interface for common dialog operations. Used for extended dialogs that use this component
 * via composition.
 */
export interface Dialog {

  /**
   * Displays the dialog.
   */
  open(): void;

  /**
   * Closes the dialog.
   */
  close(): void;

  /**
   * `true` if the dialog is currently visible.
   */
  readonly visible: boolean;
}

export interface VBtnMethods {

  /**
   * Add missing `click` declaration for VBtn component.
   */
  click(event: MouseEvent): void;
}

/**
 * An implementation of the `Dialog` interface that wraps another `Dialog`.
 */
export abstract class DialogWrapperDialog extends LservVue implements Dialog {

  /**
   * @return `Dialog` to which method calls are delegated.
   */
  protected abstract get lservDialog(): Dialog;

  /**
   * Delegates this to the associated dialog's `open()` method.
   */
  open(): void {
    this.lservDialog.open();
  }

  /**
   * Delegates this to the associated dialog's `close()` method.
   */
  close(): void {
    this.lservDialog.close();
  }

  /**
   * @return value of the `visible` property of the associated dialog.
   */
  get visible(): boolean {
    return this.lservDialog.visible;
  }
}
